// NATIVE 
import React, { useEffect, useState } from 'react'


// INSTALLED 
import { Link } from 'react-router-dom';
import { Button, Divider } from '@mui/material';


// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { TableSucursal } from '../../components/tables/TableSucursal';
import { alertInformativo } from '../../commons/texts/textAlertsInformativos';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';



export const Sucursal = () => {

  // USE STATE 
  const [canCreate, setCanCreate]     = useState<boolean>(false);


  // USE EFFECT 
  useEffect(() => {
      checkCanCreate();
  }, []);
  
  
  // CONST FUNCTIONS 
  const checkCanCreate = async() => {
        
    const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.sucursal', 'create' );
  
    if ( hasPermissionsEdit ) {
          setCanCreate(true);
    }


  }

  return (
    <div>

        <BreadCrumbsAndTitle
            title="Listado Sucursales" 
            mainModule="configuracion" 
            parent="Listado Sucursales"
            action="" />

        {
          canCreate && 
                      <div style={{ display: 'flex', justifyContent: 'end'}}>
                          <Button component={Link} to={'/configuracion/crear-sucursal'}  variant='contained' sx={{ marginBottom: 3 }}>Crear Sucursal</Button>
                      </div>
        }
        

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.sucursal} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        
        <TableSucursal />
    </div>
  )
}






